import { XCloseIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import Button from '@rsos/base-components/Button';

interface Props {
  isLabelHidden?: boolean;
  onClick: () => void;
}

export const CloseButton = ({ isLabelHidden = false, onClick }: Props) => {
  return (
    <Button
      onClick={onClick}
      dataName="collapse-button"
      btnType="invisible"
      size="xxsmall"
      noMargin
      data-name="close-button"
      title={isLabelHidden ? 'Close' : null}
    >
      <XCloseIcon color="secondaryLink" width={12} height={12} />
      {!isLabelHidden && (
        <Text ml="5px" size="xsmall" lineHeight="normal">
          Close
        </Text>
      )}
    </Button>
  );
};

export default CloseButton;
